// CategorySelect.jsx
import React from 'react';

const CategorySelect = ({ value, onChange }) => {
  const categories = [
    // 🔹 Crypto & Trading
    // "Crypto Trading Bots",
    // "Automated Trading Strategies",
    // "Binance Integration Tips",
    // "Passive Income with Crypto",
    // "BTCPay AI Updates",
    // "Trading Performance & Reports",
    // "Beginner’s Guide to Crypto Trading",
    // "Advanced Trading Techniques",
    // "Risk Management in Crypto",
    // "Crypto Market Insights & News",
    // "Profit-Sharing Models",
    // "BTC & Altcoin Analysis",
    // "Web3 & Decentralization",
    // "Crypto Tax & Accounting",
    // "Security & API Management",
    // "AI in Financial Trading",
    // "User Case Studies",
    // "Getting Started with BTCPay AI",
    // "Exchange Comparison Guides",
    // "Tech & Development Updates",
    // "Fees and Charges",
    // "Crypto News",
    // "Reinvestment Calculator",

    // 🔹 IT & Development
    "Viabig",
    "AI Development",
    "AI Agent Integration",
    "Cloud Services",
    "Productivity Tools",
    "IT Company",
    "Software Development",
    "Web Development",
    "App Development",
    "Digital Marketing",
    "IT Consultancy",
    "Technology Solutions",

    // 🔹 Education & Technology Terms
    "AI (Artificial Intelligence)",
    "API (Application Programming Interface)",
    "AR (Augmented Reality)",
    "BIOS (Basic Input Output System)",
    "CPU (Central Processing Unit)",
    "CSS (Cascading Style Sheets)",
    "DNS (Domain Name System)",
    "FTP (File Transfer Protocol)",
    "GPU (Graphics Processing Unit)",
    "HTML (HyperText Markup Language)",
    "HTTP (HyperText Transfer Protocol)",
    "HTTPS (HyperText Transfer Protocol Secure)",
    "IP (Internet Protocol)",
    "IoT (Internet of Things)",
    "ISP (Internet Service Provider)",
    "LAN (Local Area Network)",
    "ML (Machine Learning)",
    "OS (Operating System)",
    "PHP (Hypertext Preprocessor)",
    "RAM (Random Access Memory)",
    "ROM (Read Only Memory)",
    "SEO (Search Engine Optimization)",
    "SQL (Structured Query Language)",
    "URL (Uniform Resource Locator)",
    "USB (Universal Serial Bus)",
    "VPN (Virtual Private Network)",
    "VR (Virtual Reality)",
    "WAN (Wide Area Network)",
    "Wi-Fi (Wireless Fidelity)"
  ];

  return (
    <select
    className='p-2'
      id="categorySelect"
      value={value}
      onChange={onChange}
    >
      <option value="">-- Select Category --</option>
      {categories.map((category, index) => (
        <option key={index} value={category}>{category}</option>
      ))}
    </select>
  );
};

export default CategorySelect;
